import React from 'react';

import { useHistory } from 'react-router-dom';

import * as S from './styles';

const Return: React.FC = () => {
  const history = useHistory();

  const onClick = React.useCallback(() => {
    history.goBack();
  }, [history]);

  return <S.Return buttonText="Retornar para tabelas de acesso" onClick={onClick} />;
};

export default Return;
